import i18n from "i18next"
import { initReactI18next } from "react-i18next"
import en from "./locales/en/translation.json"
import sn from "./locales/sn/translation.json"

const storedLanguage =
  typeof window !== "undefined" ? window.localStorage.getItem("portal_language") : null

void i18n.use(initReactI18next).init({
  resources: {
    en: { translation: en },
    sn: { translation: sn },
  },
  lng: storedLanguage ?? "en",
  fallbackLng: "en",
  interpolation: {
    escapeValue: false,
  },
})

export function setPortalLanguage(language: string) {
  void i18n.changeLanguage(language)
  if (typeof window !== "undefined") {
    window.localStorage.setItem("portal_language", language)
  }
}

export default i18n
